routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.detailedPayment', {
      url: "zona-de-pagos/pago-detallado",
      template: `<detailed-payment sh-ctrl="shCtrl"></detailed-payment>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/detailed-payment/detailed-payment.config.js
 **/